import { gql } from '@apollo/client';

/** Every `AdminChannelHealth` field the channel-health view reads; spread it wherever one is drawn. */
export const CHANNEL_HEALTH_FIELDS = gql`
  fragment ChannelHealthFields on AdminChannelHealth {
    channel
    state
    code
    faultClass
    since
    reopensAt
    optOutSource
    lastDeliveredAt
    lastReachedAt
    lastFailedAt
  }
`;
